import React from 'react';
import PropTypes from 'prop-types';
import PipelineRunForm from '../../Common/PipelineRunForm';

// Wizard step 4 — the PAT-collecting Run step (AC-8/AC-9). Delegates to the shared
// PipelineRunForm so this behaves identically whether reached from the wizard or from
// the list's per-row "Run" action (AC-18).
const RunStep = ({ pipelineId, onTriggered }) => (
  <PipelineRunForm pipelineId={pipelineId} onTriggered={onTriggered} />
);

export default React.memo(RunStep);

RunStep.propTypes = {
  pipelineId: PropTypes.string,
  onTriggered: PropTypes.func,
};
